import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import config from "../config"
import Layout from "../pages/Layout";
import CalenderIcon from "../assets/icons/calender_icon"
import ChevronRight from "../assets/icons/chevron_right"
import HomeIcon from "../assets/icons/home_icon"
import userImage from "../assets/icons/user.png"
import EditIcon from "../images/edit_icon";
import axios from "axios"
import { Pagination } from "@mui/material";
import { toast } from "react-toastify";
import { confirmAlert, successAlert, errorAlert } from "../utils/swal";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';


const CustomerDetailPage = () => {
  const { id } = useParams();
  const [customer, setCustomer] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('orders');
  const navigate = useNavigate();
  const [newRemark, setNewRemark] = useState('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [invoices, setInvoices] = useState([]);
  



  const [ordersPage, setOrdersPage] = useState(1);
  const [quotesPage, setQuotesPage] = useState(1);
  const [invoicesPage, setInvoicesPage] = useState(1);
  const itemsPerPage = 10; // You can adjust this number


  const handleOrdersPageChange = (event, value) => {
    setOrdersPage(value);
  };

  const handleQuotesPageChange = (event, value) => {
    setQuotesPage(value);
  };

  const handleInvoicesPageChange = (event, value) => {
    setInvoicesPage(value);
  };


  const fetchCustomerDetails = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/v1/detail/${id}`);
      if (!response.ok) {
        throw new Error('Failed to fetch customer details');
      }
      const data = await response.json();
      setCustomer(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchInvoices = async () => {
  try {
    const res = await fetch(`${config.BASE_URL}/api/v1/invoice/customer/${id}`);
    if (!res.ok) {
      throw new Error("Failed to fetch invoices");
    }
    const data = await res.json();
    setInvoices(data.invoices); // assuming API returns array of invoices
  } catch (err) {
    toast.error(err.message);
  }
};


  useEffect(() => {
    fetchCustomerDetails();
  }, [id]);


  const fetchCustomerAllDetails = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/v1/customerDetails/${id}`);

      if (!response.ok) {
        throw new Error('Failed to fetch customer details');
      }
      const data = await response.json();
      setCustomerData(data);
      setNewRemark(data?.remarks[0]?.remark_text);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomerAllDetails();
  }, [id]);

  const handleDeleteAccount = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/v1/delete/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Failed to delete account. Please try again.');
      }
      toast.success('Account deleted successfully.');
      navigate('/customers');
    } catch (err) {
      setError(err.message);
      toast.error(`Error: ${err.message}`);
    } finally {
      setOpenDeleteDialog(false);
    }
  };


  const handleTabClick = (tab) => {
  setActiveTab(tab);
  if (tab === "invoices") {
    fetchInvoices();
  }
};

  const handleCreateQuoteClick = () => {
    navigate('/quotes/new-quote/' + customer._id);
  };

const formatDate = (date) => {
  if (!date) return ""; // or return "n/a", "--", etc. if you prefer
  const d = new Date(date);
  if (isNaN(d)) return ""; // additional safety for invalid dates
  const day = d.getDate().toString().padStart(2, "0");
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const year = d.getFullYear().toString().slice(-4);
  return `${day}/${month}/${year}`;
};



  const handleDeleteQuote = async (quoteId) => {
  
    const confirmDelete = await confirmAlert({
    title: "Delete Quote?",
    text: "This action cannot be undone!",
    confirmText: "Yes, Delete",
    cancelText: "Cancel",
  });

  if (!confirmDelete) return;

    if (confirmDelete) {
      try {
        const response = await axios.delete(`${config.BASE_URL}/api/v1/deleteQuote/${quoteId}`);

        if (response.status != 200) {
          throw new Error('Failed to delete the quote. Please try again.');
        }

        toast.success('Quote deleted successfully.');

        fetchCustomerAllDetails();
      } catch (err) {
        setError(err.message);
        toast.error(`Error: ${err.message}`);
      }
    }
  };


  const handleDeleteOrder = async (orderId) => {
     const confirmDelete = await confirmAlert({
    title: "Delete Order?",
    text: "This action cannot be undone!",
    confirmText: "Yes, Delete",
    cancelText: "Cancel",
  });

  if (!confirmDelete) return;
    if (confirmDelete) {
      try {
        const response = await axios.delete(`${config.BASE_URL}/api/v1/deleteOrder/${orderId}`);

        if (response.status != 200) {
          throw new Error('Failed to delete the order. Please try again.');
        }

        toast.success('Order deleted successfully.');

        fetchCustomerAllDetails();
      } catch (err) {
        setError(err.message);
        toast.err(`Error: ${err.message}`);
      }
    }
  };


 const handleAddRemark = async () => {
  if (!newRemark.trim()) {
    toast.error("Please enter a remark.");
    return;
  }

  try {
    const response = await axios.post(
      `${config.BASE_URL}/api/v1/addremarks`,
      {
        customerId: id,
        remark_text: newRemark,
      }
    );

    if (response.data.success) {
      const savedRemark = response.data.data;

      // 🔥 SAVE BACKEND RESPONSE DIRECTLY
      setCustomerData((prevData) => ({
        ...prevData,
        remarks: [savedRemark], // ❗ replace, don't push
      }));

      toast.success("Remark saved successfully");
    } else {
      toast.error("Failed to save remark");
    }
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  }
};

  const handleDeleteInvoice = async(id)=>{
   const confirmDelete = await confirmAlert({
    title: "Delete Invoice?",
    text: "This action cannot be undone!",
    confirmText: "Yes, Delete",
  });

  if (!confirmDelete) return;

    if(confirmDelete){
 try {
       const response = await axios.delete(`${config.BASE_URL}/api/v1/delete-invoice/${id}`);
       console.log(response?.data?.success,"response?.data?.success")
       if (response?.data?.success) {
           toast.success('Invoice deleted successfully.');

        fetchInvoices();
       }
    } catch (error) {
      console.log(error,"error")
    }
    }
   
  }

  // --- NEW LOGIC: Calculate the Latest Quote Date from the quotes array ---
  const getLatestQuoteDate = () => {
    if (customerData?.quotes && customerData.quotes.length > 0) {
      // Reduce array to find the object with the latest date
      const latest = customerData.quotes.reduce((prev, current) => {
        return new Date(prev.quoteDate) > new Date(current.quoteDate)
          ? prev
          : current;
      });
      return formatDate(latest.quoteDate);
    }
    return "N/A";
  };
  //

  return (
    <Layout>
      <div className="customer-detail-page">
        <header className="header">
          <h1>Customer Account</h1>
          <p> <HomeIcon /> / Customers / Customer Account</p>
        </header>

        <div className="page_card_body">

          {loading && <p>Loading customer details...</p>}
          {error && <p className="error">{error}</p>}

          {!loading && !error && customer && (
            <div className="customer-details">
              <div className="profile-section">
                <div className="customer_image">
                  <img
                    src={customer.profile_picture ? `${config.BASE_URL}/${customer.profile_picture}` : userImage}
                    alt="Profile"
                  />
                </div>
                <div className="customer_details">
                  <h2>{customer.customer_name}</h2>

                  {customer.customer_type && (
                    <p className="customer-type">
                      <strong>Type:</strong> {customer.customer_type}
                    </p>
                  )}

                  <div className="details_outer">
                    <p>Last Quote:</p>
                    <div className="quote_date">
                      <p>{getLatestQuoteDate()}</p>
                    </div>
                  </div>

                  <button onClick={handleCreateQuoteClick} className="btn">
                    Create New Quote <ChevronRight />
                  </button>
                </div>

                <div className="edit_profile">
                  <Link to={`/edit-customer/${customer._id}`}>
                    <EditIcon />
                  </Link>
                </div>
              </div>
              <div className="contact_details">
                <h3>Contact Details</h3>
                <div className="contact_details_inner">
                  <div className="address comman_detail_item">
                    <p>Address: </p>
                    <div>
                      {customer.address}
                    </div>
                  </div>
                  <div className="mobile comman_detail_item">
                    <p>Mobile: </p>
                    <div>
                      {customer.mobile}
                    </div>
                  </div>
                  <div className="email comman_detail_item">
                    <p>Email: </p>
                    <div>
                      {customer.email}
                    </div>
                  </div>
                </div>
              </div>

              <div className="user_site_detils_showcase">
                <div className="tabs">
                  <button onClick={() => handleTabClick('orders')} className={activeTab === 'orders' ? 'active' : ''}>Orders</button>
                  <button onClick={() => handleTabClick('quotes')} className={activeTab === 'quotes' ? 'active' : ''}>Quotes</button>
                  <button onClick={() => handleTabClick('invoices')} className={activeTab === 'invoices' ? 'active' : ''}>Invoices</button>
                  <button onClick={() => handleTabClick('remarks')} className={activeTab === 'remarks' ? 'active' : ''}>Remarks</button>
                </div>

                <div className="tab-content">
                  {activeTab === 'orders' && (
                    <div className="orders">
                      <table className="common_table">
                        <thead>
                          <tr>
                            <th>Order Date</th>
                            <th>Order No</th>
                            <th>Amount</th>
                            <th>Wedding Date</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customerData?.orders?.slice((ordersPage - 1) * itemsPerPage, ordersPage * itemsPerPage).map(order => (
                            <tr key={order.order_no}>
                              <td>{formatDate(order.order_date)}</td>
                              <td>{order.order_no}</td>
                              <td>{order.amount}</td>
                              <td>{formatDate(order.wedding_date)}</td>
                              <td>{order.status}</td>
                              <td>
                                <button className="edit" onClick={() => navigate(`/edit-order/${order._id}`)}>Edit</button>
                                <button className="delete" onClick={() => handleDeleteOrder(order._id)} style={{marginTop:"5px"}}>Delete</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {customerData?.orders?.length > itemsPerPage && (
                        <Pagination
                          variant="outlined" shape="rounded"
                          count={Math.ceil(customerData.orders.length / itemsPerPage)}
                          page={ordersPage}
                          onChange={handleOrdersPageChange}
                          color="primary"
                          style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}
                        />
                      )}
                    </div>
                  )}
                  {activeTab === 'quotes' && (
                    <div className="orders">
                      <table className="common_table">
                        <thead>
                          <tr>
                            <th>Quote Date</th>
                            <th>Quote No</th>
                            <th>Amount</th>
                            <th>Wedding Date</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customerData?.quotes?.slice((quotesPage - 1) * itemsPerPage, quotesPage * itemsPerPage).map(quote => (
                            <tr key={quote.quoteNo}>
                              <td>{formatDate(quote.quoteDate)}</td>
                              <td>{quote.quoteNo}</td>
                              <td>{quote.totalPrice}</td>
                              <td>{formatDate(quote.weddingDate)}</td>
                              <td>{quote.status}</td>
                              <td>
                                <button className="edit" onClick={() => navigate(`/edit-quote/${quote._id}`)}>Edit</button>
                                <button className="delete" onClick={() => handleDeleteQuote(quote._id)} style={{marginTop:"5px"}}>Delete</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {customerData.quotes?.length > itemsPerPage && (
                        <Pagination
                          variant="outlined" shape="rounded"
                          count={Math.ceil(customerData.quotes.length / itemsPerPage)}
                          page={quotesPage}
                          onChange={handleQuotesPageChange}
                          color="primary"
                          style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}
                        />
                      )}
                    </div>
                  )}

                  {activeTab === 'invoices' && (
                    <div className="orders">
                      <table className="common_table">
                        <thead>
                          <tr>
                            <th>Invoice Date</th>
                            <th>Invoice No</th>
                            <th>Amount</th>
                            <th>Amount Paid</th>
                            <th>Amount Due</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoices.slice(
  (invoicesPage - 1) * itemsPerPage,
  invoicesPage * itemsPerPage
).map(order => (
                            <tr key={order.invoice_no}>
                              <td>{formatDate(order.invoice_date)}</td>
                              <td>{order.invoice_no}</td>
                              <td>{order.amount}</td>
                              <td>{order.amount_paid}</td>
                              <td>{order.amount_due}</td>
                              <td>
                                <button className="edit" onClick={() => navigate(`/edit-invoice/${order._id}`)}>Edit</button>
                                <button onClick={()=>handleDeleteInvoice(order._id)} className="delete" style={{marginTop:"5px"}}>Delete</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {customerData.invoices?.length > itemsPerPage && (
                        <Pagination variant="outlined" shape="rounded"
                          count={Math.ceil(invoices.length / itemsPerPage)}
                          page={invoicesPage}
                          onChange={handleInvoicesPageChange}
                          color="primary"
                          style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}
                        />
                      )}
                    </div>
                  )}
                  {activeTab === "remarks" && (
  <div className="remarks">
    <div className="add-remark">
      <textarea
        value={newRemark}
        onChange={(e) => setNewRemark(e.target.value)}
        placeholder="Add your remark here..."
      />
      <button onClick={handleAddRemark}>Save</button>
    </div>
  </div>
)}
                </div>
              </div>
              <div className="actions">
                <button className="delete-account" onClick={() => setOpenDeleteDialog(true)}>
                  Delete Account
                </button>
                <Dialog
                  open={openDeleteDialog}
                  onClose={() => setOpenDeleteDialog(false)}
                >
                  <DialogTitle>Delete Account</DialogTitle>
                  <DialogContent>
                    <Typography>
                      Are you sure you want to delete this account? This action cannot be undone.
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)} color="primary">
                      Cancel
                    </Button>
                    <Button onClick={handleDeleteAccount} color="error" variant="contained">
                      Delete
                    </Button>
                  </DialogActions>
                </Dialog>

                <button
                  className="view-all-customers"
                  onClick={() => navigate('/customers')}
                >
                  All Customers
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default CustomerDetailPage;
